import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import IssueLabel from './IssueLabel';
import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import translateType from '../utils/translateIssueType';

const useStyles = makeStyles(theme => ({
  amountLabel: {
    marginLeft: theme.spacing(1)
  }
}));

export interface IssueTypeLabelProps {
  severity: number
  type: number | string
  amount?: number
}

export default function IssueTypeLabel ({ severity, type, amount = 1 }: IssueTypeLabelProps) {
  const classes = useStyles();
  return (
    <IssueLabel severity={parseSeverity(severity)}>
      {translateType(type)}
      {(amount > 1) && <span className={classes.amountLabel}>{`(${amount.toString()})`}</span>}
    </IssueLabel>
  );
}
